module.exports = __webpack_public_path__ + "img/check-row.3727d3c2.svg";